import React, {useState} from "react";
import close from "../../images/Close.svg";
import axios from 'axios';
const modal = {
    width:500,
    height:250,
    position:'absolute',
    zIndex:1000,
    background:'white',
    top:'50%',
    left:'50%',
    right:'50%',
    borderRadius:20,
    padding:40,
    transform: 'translate(-50%, -50%)',
    boxShadow:'rgba(0, 0, 0, 0.08)',
}
const closeStyle = {
    cursor:'pointer',
    position: 'absolute',
    right : 40
}
export default function CloseModal(props) {
return(
           <>
               <div className="modal-back"></div>
               <div style={modal} className="-modal d-flex flex-column justify-content-between">
                 <div>
                     <img  onClick={() => props.selfClose()} style={closeStyle} src={close} alt="close"/>
                     <p className="f16 dark-gary fw700">Are you sure you want to close the wizard? </p>
                     <p className="mt-3 f14 fw300">If yes, then any unsaved data will be lost.</p>
                 </div>
                   <div className="d-flex mt-24 justify-content-center">
                       {/*<div style={{width:197}} className={`btn btn-active ${name && ''} ${loading && 'btn-loading-small'} btn btn-by-loading mr-24`}>*/}
                       {/*    <p>save</p>*/}
                       {/*    <p>saving</p>*/}
                       {/*</div>*/}
                       <div style={{width:150,padding:'10px 0 0',marginRight:24}} className="btn" onClick={() => props.close()}>Yes</div>
                       <div style={{width:150,padding:'10px 0 0'}} className="btn btn-outline" onClick={() => props.selfClose()}>No</div>
                   </div>
               </div>
           </>
)
}
